import { useGetToken } from '../services/hooks/subscribe/subscribe';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NotFound from './NotFound';

export default function Login() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [token, setToken] = useState(searchParams.get('token') || '');
  const [userId, setUserId] = useState('');
  const { data: userData, isLoading: isUserLoading } = useGetToken({
    TOKEN: token,
    enabled: Boolean(token !== ''),
    onSuccess(data) {
      navigate(`/`);
      return;
    },
    onError() {
      navigate(`/404`);
      return;
    },
  });

  return (
    <>
      {token === '' ? (
        <NotFound />
      ) : (
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="text-center">
            <div className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-32 w-32 mx-auto mb-4"></div>
            <h2 className="text-xl font-semibold">Memuat...</h2>
            <p className="text-gray-600">
              Tunggu sebentar ya, kami sedang memproses data kamu.
            </p>
          </div>
        </div>
      )}
    </>
  );
}
